import { render, staticRenderFns } from "./ContentBody.vue?vue&type=template&id=63191bb0&scoped=true&"
import script from "./ContentBody.vue?vue&type=script&lang=js&"
export * from "./ContentBody.vue?vue&type=script&lang=js&"
import style0 from "./ContentBody.vue?vue&type=style&index=0&id=63191bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63191bb0",
  null
  
)

export default component.exports